var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { mapGetters, mapActions } from "vuex";
import { Component, Emit, Prop } from "vue-property-decorator";
import Add from "../Add.vue";
import SignView from "@/page/purchasein/components/SignView.vue";
import AccoutCheckService from '../../../api/AccoutCheckService';
import InvoiceInfoDialog from '../components/InvoiceInfoDialog.vue';
import GenerateInvoice from "@/page/accountcheck/components/GenerateInvoice";
var BillTable = (function (_super) {
    __extends(BillTable, _super);
    function BillTable() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.imgs = [];
        _this.swiperShow = false;
        _this.tableHeight = document.documentElement.clientHeight - 280;
        _this.signImageOpen = false;
        _this.signImageArr = [];
        return _this;
    }
    BillTable.prototype.selectionChange = function () { };
    BillTable.prototype.created = function () {
        this.service = AccoutCheckService.getInstance();
    };
    Object.defineProperty(BillTable.prototype, "isAnyBusinessOpenMultiCurrency", {
        get: function () {
            var allSettingScale = this.$store.state.allSettingScale || [];
            return allSettingScale.some(function (item) {
                if (item.other_config && item.other_config.is_open_multi_currency == 1)
                    return true;
                if (item.is_open_multi_currency == 1)
                    return true;
                return false;
            });
        },
        enumerable: true,
        configurable: true
    });
    BillTable.prototype.generateInvoice = function (row) {
        var _this = this;
        this.currentRow = row;
        var instance = this.$dialog(GenerateInvoice, {
            data: {
                id: row.order_id
            },
            showFooter: true
        }, {
            title: '发票开具',
            width: 440,
            height: 300,
            zIndex: 2000
        }).instance;
        instance.$on('openDocumentList', function () {
            _this.uploaderInvoice(row);
            _this.$emit('search');
        });
        instance.$on('refresh', function () {
            _this.$emit('search');
        });
        instance.$on('close', function () {
            console.log('close>>>');
            instance.$destroy();
        });
        instance.$on('getInvoiceStatus', function () {
            _this.getInvoiceStatus();
        });
    };
    BillTable.prototype.toEdit = function (row) {
        this.$emit("add-tab", {
            component: Add,
            title: "编辑对账单",
            showExist: true,
            name: "edit-account-check" + row.order_id,
            opener: this,
            cprops: {
                handleType: "edit",
                detail: __assign({}, row)
            }
        });
    };
    BillTable.prototype.toDetail = function (row) {
        this.$emit("to-detail", row);
    };
    BillTable.prototype.viewSignImg = function (row) {
        var _this = this;
        this.service.getSignList({ order_id: row.order_id })
            .then(function (res) {
            var data = res.data;
            if (data.success && data.data.length) {
                if (data.data.length) {
                    var sign_img = data.data;
                    sign_img = Array.isArray(sign_img) ? sign_img : [];
                    sign_img.forEach(function (item) {
                        item.img = item.url;
                    });
                    console.log(111, sign_img);
                    _this.signImageArr = sign_img;
                    _this.signImageOpen = true;
                }
                else {
                    _this.$message.error("暂无签字图片！");
                }
            }
            else {
                _this.$message.warning('暂无签字图片！');
            }
        }, function (err) { });
    };
    BillTable.prototype.closeSign = function () {
        this.signImageOpen = false;
    };
    BillTable.prototype.getInvoiceStatus = function () {
        this.uploaderInvoice(this.currentRow);
    };
    BillTable.prototype.toLookImg = function (row) {
        var _this = this;
        this.swiperShow = true;
        this.service.getOrderDocumentList({ order_id: row.order_id })
            .then(function (res) {
            var data = res.data;
            if (data.success && data.data.length) {
                if (data.data.length) {
                    var sign_img = data.data;
                    _this.imgs = Array.isArray(sign_img) ? sign_img : [];
                }
                else {
                    _this.$message.error("暂无发票图片！");
                }
            }
            else {
                _this.$message.warning('暂无发票图片！');
            }
        }, function (err) { });
        this.$refs.carousel.setActiveItem(0);
    };
    BillTable.prototype.uploaderInvoice = function (row) {
        var _this = this;
        var instance = this.$dialog(InvoiceInfoDialog, {
            data: {
                detail: row,
                token: this.user.token,
                type: 'edit',
                getAuth: this.getAuth,
                parentPageAuth: this.Root_PageAuth
            }
        }, {
            title: "发票信息",
            width: 640,
            height: 560,
            zIndex: 1002,
        }).instance;
        instance.$on("submitSuccess", function (res) {
            _this.$emit('search');
        });
    };
    __decorate([
        Prop({
            required: true,
            type: Array
        })
    ], BillTable.prototype, "data", void 0);
    __decorate([
        Emit("selection-change")
    ], BillTable.prototype, "selectionChange", null);
    BillTable = __decorate([
        Component({
            computed: __assign({}, mapGetters({
                openedCodeData: 'openedCodeData',
                user: 'user',
            })),
            components: {
                SignView: SignView,
                GenerateInvoice: GenerateInvoice
            },
            methods: __assign({}, mapActions(["getAuth"])),
        })
    ], BillTable);
    return BillTable;
}(Vue));
export default BillTable;
